import { r as getCurrentUser, t as getBio, v as getCounts } from "./api.js";
async function handle({ event, resolve }) {
  event.locals.currentUser = await getCurrentUser(event.cookies.get("sessionid"));
  event.locals.bio = await getBio();
  event.locals.counts = await getCounts();
  event.locals.origin = event.url.origin;
  const response = await resolve(event);
  return response;
}
export {
  handle
};
